/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./InventoryView.vue?vue&type=template&id=a5dfec52&scoped=true"
import script from "./InventoryView.vue?vue&type=script&lang=js"
export * from "./InventoryView.vue?vue&type=script&lang=js"
import style0 from "./InventoryView.vue?vue&type=style&index=0&id=a5dfec52&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5dfec52",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a5dfec52')) {
      api.createRecord('a5dfec52', component.options)
    } else {
      api.reload('a5dfec52', component.options)
    }
    module.hot.accept("./InventoryView.vue?vue&type=template&id=a5dfec52&scoped=true", function () {
      api.rerender('a5dfec52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/InventoryView.vue"
export default component.exports